import cn from 'classnames';
import type { PropsWithChildren, ToggleEvent } from 'react';
import gtag from '../analytics/gtag';
import * as style from './AnchoredPopover.module.css';

interface Props extends ButtonProps {
    className?: string;
    id: string;
}

export interface ButtonProps {
    buttonChildren: React.ReactNode;
    'data-modal-name'?: string;
    'aria-label'?: string;
}

export default function AnchoredPopover({ className, id, children, buttonChildren, ...buttonProps }: PropsWithChildren<Props>) {
    return (
        <object>
            <button className={style.popoverButton} popoverTarget={id} {...buttonProps}>
                {buttonChildren}
            </button>
            <div className={cn(style.anchoredPopover, className)} id={id} popover="auto" onToggle={trackPopover}>
                {children}
            </div>
        </object>
    );
}

function trackPopover(e: ToggleEvent) {
    if (e.newState === 'open') {
        gtag('event', 'modal_view', {
            modal_name: (e.nativeEvent.source as HTMLElement)?.dataset?.modalName,
            link_text: e.nativeEvent.source?.textContent,
        });
    }
}
